<template>
  <div id="sign-up" class="d-flex flex-column flex-grow-1 justify-content-center align-items-center">
    <img class="main-logo" src="@/assets/svg/Logo_Horizontal_Gradient_Dark_Transparent.svg" alt="logo" />
    <SignUpForm class="signup-form" :title="$t('signup.header')" @on-submit="signUp" />
    <div class="to-login text-muted">
      <p>
        {{ $t("signup.to-login") }}
        <router-link :to="{ name: 'login' }">
          {{ $t("signup.login-link") }}
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import SignUpForm from "@/components/SignUpForm";
export default {
  components: { SignUpForm },
  name: "Signup",
  methods: {
    signUp(info) {
      let data = info;
      delete data.user.reenteredpassword;
      delete data.user.check;
      this.signingUp = true;
      this.$store
        .dispatch("signUp", data)
        .then(() => {
          window.lintrk("track", { conversion_id: 6824802 });
        })
        .catch((error) => {
          console.log("Error", error);
          this.error = true;
          this.signingUp = false;
        });
    }
  }
};
</script>

<style lang="less">
#sign-up {
  background-color: #f1f1f1;

  .to-login {
    margin-top: 12px;
  }

  .main-logo {
    margin-bottom: 40px;
    width: 180px;
  }

  .signup-form {
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    //   width: 750px;
    h1 {
      margin: 40px 0 0 55px;
    }
    form {
      padding: 0 55px 40px 55px;
    }
  }
}

@media only screen and (max-width: 750px) {
  #sign-up {
    .sign-up-box {
      width: 90%;
      form {
        display: block;
        .final-group {
          margin-top: 10px;
        }
      }
    }
    .requirements {
      position: relative;
    }
  }
}
</style>
